export default "__VITE_ASSET__CThJFXdq__"